import { apiFetch } from "../../http";
export async function deleteTravelEquipment(params) {
    const { baseUrl, travelPlanId, equipmentId, token } = params;
    return apiFetch(`/travel/api/delete_travel_equipment/${travelPlanId}/${equipmentId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
    });
}
export async function toggleTravelEquipmentChecked(params) {
    const { baseUrl, travelPlanId, equipmentId, isChecked, token, csrfToken } = params;
    return apiFetch(`/travel/api/toggle_travel_equipment_checked/${travelPlanId}/${equipmentId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({ is_checked: isChecked })
    });
}
export async function saveTravelEquipment(params) {
    const { baseUrl, travelPlanId, equipmentId, payload, token, csrfToken } = params;
    const isUpdate = equipmentId != null;
    const path = isUpdate
        ? `/travel/api/update_travel_equipment/${travelPlanId}/${equipmentId}/`
        : `/travel/api/create_travel_equipment/${travelPlanId}/`;
    return apiFetch(path, {
        baseUrl,
        token,
        method: isUpdate ? "PUT" : "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify(payload),
    });
}
export async function saveEquipmentSet(params) {
    const { baseUrl, travelPlanId, payload, token, csrfToken } = params;
    return apiFetch(`/travel/api/create_equipment_set/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify(payload)
    });
}
export async function setEquipmentSetForTravel(params) {
    const { baseUrl, travelPlanId, equipmentSetId, token, csrfToken } = params;
    return apiFetch(`/travel/api/set_equipment_set/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({ equipment_set_id: equipmentSetId })
    });
}
export async function getTravelEquipment(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_travel_equipment/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function changeEquipmentSet(params) {
    const { baseUrl, travelPlanId, equipmentSetId, token, csrfToken } = params;
    return apiFetch(`/travel/api/equipment_set_change/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify({ equipment_set_id: Number(equipmentSetId) }),
    });
}
export async function getEquipmentSets(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_equipment_sets/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET",
    });
}
